import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { setSubmitting, setError } from '../Slice/unifiedFormSlice';
import Cookies from 'js-cookie';

interface SubmitApplicationPayload {
  fileUrl: string;
  publisher_id: string;
  fa_name: string;
  en_name: string;
  category: string;
}

export const submitApplication = createAsyncThunk(
  'unifiedForm/submitApplication',
  async (payload: SubmitApplicationPayload, { dispatch, rejectWithValue }) => {
    dispatch(setSubmitting(true));
    try {
      console.log('Sending request with payload:', {
        publisher_id: payload.publisher_id,
        fa_name: payload.fa_name,
        en_name: payload.en_name,
        category: payload.category,
        file_url: payload.fileUrl,
      });

      const token = Cookies.get('authToken');
      console.log('Token from Cookies:', token || 'No token found');

      const response = await apiClient.post(
        '/v2/publisher/applications/createBasicInformation',
        {
          publisher_id: payload.publisher_id,
          fa_name: payload.fa_name,
          en_name: payload.en_name,
          category: payload.category,
          application_file_url: payload.fileUrl, // ارسال URL به جای فایل
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        },
      );

      console.log('Full server response:', JSON.stringify(response, null, 2));
      console.log('Response data:', JSON.stringify(response.data, null, 2));

      if (response.status === 200) {
        const appData = response.data.data || response.data;
        const appId =
          appData.id ||
          appData.application_id ||
          appData.application?.id ||
          appData.data?.id ||
          appData.data?.application_id;
        if (!appId) {
          console.error('No application ID found in response:', appData);
          return rejectWithValue('شناسه اپلیکیشن در پاسخ سرور یافت نشد');
        }
        return { ...appData, id: appId };
      } else {
        console.error('Unexpected response status:', response.status);
        return rejectWithValue(`وضعیت پاسخ غیرمنتظره: ${response.status}`);
      }
    } catch (error: any) {
      console.error('Error in submitApplication:', error);
      
      // The api client interceptor already unwrapped the response body, so
      // this is {message, errors} rather than an axios error.
      if (error?.errors || error?.message) {
        return rejectWithValue(error);
      }

      const errorMessage = error?.error || 'خطا در ارسال اطلاعات اپلیکیشن';
      dispatch(setError(errorMessage));
      return rejectWithValue(errorMessage);
    } finally {
      dispatch(setSubmitting(false));
    }
  },
);